<template>
  <LinkTable
    label="4.4.1 Risk Register Links"
    :links="store.plan.risk_register_links"
    :readonly="readonly"
    @add="addLink($event)"
    @update="updateLink($event.id, $event.link)"
    @delete="deleteLink($event)"
  />
</template>

<script setup lang="ts">
import { useAMPStore } from "@/store/asset-management-plan";
import LinkTable from "./LinkTable.vue";
import { RiskRegisterLink } from "@/classes";

const props = defineProps<{
  readonly?: boolean;
}>();

const emit = defineEmits<{
  delete: [item: RiskRegisterLink];
}>();

const store = useAMPStore();

const addLink = (link: string) => {
  const newLink = new RiskRegisterLink();
  newLink.asset_management_plan_id = store.plan.id;
  newLink.link = link;
  store.plan.risk_register_links.push(newLink);
};

const updateLink = (id: string, value: string) => {
  const link = store.plan.risk_register_links.find((l) => l.id === id);
  if (link) {
    link.link = value;
  }
};

const deleteLink = (id: string) => {
  const index = store.plan.risk_register_links.findIndex((l) => l.id === id);
  if (index !== -1) {
    const link = store.plan.risk_register_links[index];
    store.plan.risk_register_links.splice(index, 1);
    emit("delete", link);
  }
};
</script>
